import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Tooltip, TooltipContent } from '@atresmedia/intranet-tooltip';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import Title from '../../../core/Title';
import { Pill, PillTextIcon } from '../../../core/Pill';
import DropdownInput from '../../../core/DropdownInput';
import Button from '../../../core/Buttons';

const StyledBoxContainer = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  padding: ${rem('20px')} ${rem('20px')};
  max-width: ${rem('500px')};
`;

const StyledBoxInfoContainer = styled.div`
  padding: 1.25rem 1.25rem;
  align-items: center;
  display: block;
  text-align: center;
`;

const StyledBoxInfoContent = styled.div``;

const StyledBoxContainerFile = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  padding: ${rem('20px')} ${rem('20px')};
`;

const StyledWithholding = styled.div`
  width: 100%;
  display: block;
  background-color: white;
`;

const StyledTitle = styled.h3`
  font-weight: bold;
  font-size: ${rem('14px')};
  margin: 0 0 ${rem('30px')};
`;

const StyledTitleRRHH = styled(Title)`
  text-align: center;
  margin-bottom: ${rem('100px')};
`;

const StyledWithholdingContent = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  max-width: ${rem('120px')};
  ${mediaqueries.greaterThan('480px')`
    flex-wrap: nowrap;
  `};
`;

const StyledWithholdingFileContent = styled.div`
  width: 100%;
  text-align: center;
  ${mediaqueries.greaterThan('480px')`
    flex-wrap: nowrap;
  `};
`;

const StyledBtnContent = styled.div``;
const StyledBtnFileContent = styled.div`
  margin-top: 2%;
`;

const StyledDropdown = styled(DropdownInput)`
  margin: 0 0 ${rem('30px')};
  ${mediaqueries.greaterThan('480px')`
    flex: 1;
  `};
`;

const StyledLabel = styled.span`
  font-weight: bold;
  font-size: ${rem('14px')};
  margin-right: ${rem('10px')};
`;

const StyledButton = styled(Button)`
  font-size: ${rem('14px')};
  height: ${rem('32px')};
  line-height: ${rem('8px')};
  margin: ${props =>
    props.margin ? `0 10px ${rem('60px')}` : `0 0 ${rem('30px')}`};
`;

const StyledTooltip = styled(Tooltip)`
  position: absolute;
  top: ${rem('15px')};
  right: ${rem('15px')};
`;

const StyledTooltipContent = styled(TooltipContent)`
  font-family: ${props => props.theme.fonts.regular};
  font-size: ${rem('13px')};
  line-height: 1.23;
  text-align: left;
  position: absolute;
  top: ${rem('30px')};
  left: ${rem('-260px')};
  &:after {
    left: ${rem('267px')};
  }
`;

const StyledPill = styled(Pill)`
  margin: 0 0 ${rem('30px')};
  box-sizing: border-box;
  width: 100%;
  max-width: ${rem('460px')};
  position: relative;
  order: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 4rem;
  ${props =>
    props.featured &&
    css`
      order: 0;
      @media (min-width: ${props => props.theme.mediaqueries.desktop}) {
        order: 1;
      }
    `};
  @media (min-width: ${props => props.theme.mediaqueries.desktop}) {
    width: ${rem('234px')};
    margin-bottom: 0;
    margin-left: ${rem('60px')};
    &:first-child {
      margin-left: 0;
    }
  }
`;

const StyledPillText = styled.h2`
  font-size: ${rem('16px')};
  font-family: ${props => props.theme.fonts.medium};
  color: ${props => props.theme.colors.dark_2};
  margin: 0 0 ${rem('25px')} 0;
  font-weight: initial;
  @media (min-width: ${props => props.theme.mediaqueries.desktop}) {
    margin: 0 ${rem('20px')} ${rem('25px')};
    font-size: ${rem('18px')};
    font-family: ${props => props.theme.fonts.regular};
  }
`;

const StyledPillTextIcon = styled(PillTextIcon)`
  position: relative;
  top: ${rem('-2px')};
  left: ${rem('-2px')};
`;

const StyledPillsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  padding: 0 ${rem('20px')};
  @media (min-width: ${props => props.theme.mediaqueries.desktop}) {
    padding: ${rem('60px')} ${rem('30px')} 0 ${rem('30px')};
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }
  ${mediaqueries.greaterThan('1480px')`
   flex-direction: row;
   justify-content: space-evenly;
  `};
`;

const StyledContent = styled.div`
  padding: 10rem 0;
  ${mediaqueries.greaterThan('1480px')`
   padding: ${props => (props.rrhh ? '7rem 0' : '20rem 0')};
   height: ${props => props.rrhh && '90vh'};
  `};
`;

export {
  StyledBoxContainer,
  StyledBoxContainerFile,
  StyledBoxInfoContainer,
  StyledBoxInfoContent,
  StyledWithholdingFileContent,
  StyledWithholding,
  StyledTitle,
  StyledTitleRRHH,
  StyledWithholdingContent,
  StyledBtnContent,
  StyledBtnFileContent,
  StyledDropdown,
  StyledLabel,
  StyledButton,
  StyledTooltip,
  StyledTooltipContent,
  StyledPill,
  StyledPillText,
  StyledPillTextIcon,
  StyledPillsWrapper,
  StyledContent
};
